import { render, staticRenderFns } from "./GraficoIMA.vue?vue&type=template&id=e1c3a3f0&scoped=true"
import script from "./GraficoIMA.vue?vue&type=script&lang=js"
export * from "./GraficoIMA.vue?vue&type=script&lang=js"
import style0 from "./GraficoIMA.vue?vue&type=style&index=0&id=e1c3a3f0&prod&scoped=true&lang=css"
import style1 from "./GraficoIMA.vue?vue&type=style&index=1&id=e1c3a3f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1c3a3f0",
  null
  
)

export default component.exports